var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBusinessStarter = function SvgBusinessStarter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M32 36c-7.85 0-14-6.15-14-14S24.28 8 32 8s14 6.28 14 14-6.15 14-14 14m0-26c-6.62 0-12 5.38-12 12s5.27 12 12 12 12-5.27 12-12-5.38-12-12-12M54 56a.99.99 0 0 1-.93-.64C48.74 44.23 41.8 42 32 42s-16.73 2.24-21.07 13.36c-.2.51-.78.77-1.29.57s-.77-.78-.57-1.29C13.8 42.49 21.66 40 32 40s18.2 2.49 22.93 14.64c.2.51-.05 1.09-.57 1.29-.12.05-.24.07-.36.07"
  })));
};
export default SvgBusinessStarter;